enum SupportedBadge {
  FSC = 'logoFsc',
  PFSC = 'logoPfsc',
  FSCPFSC = 'logoFscPfsc',
  OVERNIGHT = 'overnightAvailable',
  ECOFRIENDLY = 'ecoFriendly',
  ONLINEDESIGN = 'onlineDesign',
}

export default SupportedBadge;
